module.exports = __webpack_public_path__ + "img/e_3_18_r.197a9c96.png";